import type { CampaignListItem, CampaignListItemServer } from '@metapic-apps/shared'

import { normalizeMoney } from '@/lib/adapters/common.adapter'
import { normalizeImage } from '@/lib/adapters/image.adapters'

export const normalizeCampaignListItem = (data: CampaignListItemServer): CampaignListItem => {
  return {
    id: data.id,
    type: data.type,
    status: data.status,
    internalName: data.name || '',
    name: data.campaign_title || '',
    advertiserName: data.store_name,
    ...(data.store_logo && { advertiserLogo: normalizeImage(data.store_logo) }),
    advertiserId: data.store_id,
    advertiserCurrency: data.currency,
    currentClicks: data.constraints?.current_clicks,
    maxClicks: data.constraints?.max_clicks,
    currentMoney: data.constraints?.current_money,
    maxMoney: data.constraints?.max_money,
    validFrom: data.constraints?.valid_from,
    validUntil: data.constraints?.valid_until,
    createdAt: data.created_at,
    ...(data.image && { image: normalizeImage(data.image) }),
    ...(data.targets && {
      targets: {
        users: data.targets.user_ids,
        storeGroups: data.targets.store_group_ids,
        userTags: data.targets.user_tag_ids,
        clients: data.targets.client_ids,
        revenueTiers: data.targets.revenue_tier_ids,
        emails: data.targets.emails,
        socialMediaIdentifiers: data.targets.social_media_identifiers,
      },
    }),
    perUserLimit: Boolean(data.constraints?.per_user_limit),
    ...(data.consumed_budget && {
      consumedBudget: {
        amount: Number(data.consumed_budget.amount),
        currency: data.consumed_budget.currency,
      },
    }),
    ...(data.budget_limit_v2 && { budgetLimit: normalizeMoney(data.budget_limit_v2) }),
    ...(data.token && { token: data.token }),
  }
}
